import React, { Component } from 'react';
import { View } from 'react-native';

import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  VFButton,
  VFText,
  VFInput,
  QuickActionMenu,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';

import styles from './ChangeDeviceNameModal.Style';

class ChangeDeviceNameModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceName: null,
      isDeviceNameSaved: false,
    };
  }

  onSaveDeviceName = () => {
    this.setState({ isDeviceNameSaved: true });
    if (_.isFunction(this.props.onDeviceNameChange)) {
      this.props.onDeviceNameChange(this.state.deviceName);
    }
  };

  getLottieProps = () => ({
    type: 'tick',
    autoPlay: true,
    loop: false,
    lottieViewStyle: { width: 140, height: 140 },
  });

  toggleQuickAction = () => {
    this.props.onCloseQuickAction();
    this.setState({ isDeviceNameSaved: false, deviceName: null });
  };

  renderCongratulationsView = () => {
    return (
      <>
      </>
    );
  };

  renderChangeDeviceNameAction = () => {
    const { theme } = this.props;

    return (
      <>
        <VFText i18nKey="change_device_name_quick_action_subtitle" style={styles.subTitleText} />

        <VFInput
          onChangeText={value => this.setState({ deviceName: value })}
          value={this.state.deviceName}
          fontSize={14}
          label="change_device_name_quick_action_input_label"
          baseColor={theme.colors.textInput.default.baseColor}
          tintColor={theme.colors.textInput.default.tintColor}
          selectionColor={theme.colors.textInput.default.selectionColor}
          textColor={theme.colors.textColor}
          containerStyle={styles.inputContainer}
          testID={FrameworkTestKeys.ChangeDeviceNameVFInput}
        />

        <VFButton
          type="primary"
          title="change_device_name_quick_action_save_button"
          onPress={this.onSaveDeviceName}
          disabled={!this.state.deviceName}
          style={styles.primaryBtn}
          textStyle={styles.btnContainer}
          disabledStyle={styles.disabledBUttonStyle(this.props.theme)}
          disabledTextStyle={styles.disabledTextStyle(this.props.theme)}
        />

        <VFButton
          type="secondary"
          title="change_device_name_quick_action_cancel_button"
          onPress={this.toggleQuickAction}
          style={styles.secondaryBtn}
          textStyle={styles.btnContainer}
        />
      </>
    );
  };

  render() {
    return (
      <QuickActionMenu
        type="secondary"
        withKeyboardAvoid
        isVisible={this.props.isVisible}
        toggleModal={this.toggleQuickAction}
        withCloseButton={false}
        title="cvm_device_name_title"
        titleStyle={styles.modalTitleStyle}
        containerStyle={styles.containerStyle(this.props.theme)}
      >
        <View>
          {!this.state.isDeviceNameSaved
            ? this.renderChangeDeviceNameAction()
            : this.renderCongratulationsView()}
        </View>
      </QuickActionMenu>
    );
  }
}

ChangeDeviceNameModal.defaultProps = {
  theme: LightThemeColors,
};
ChangeDeviceNameModal.propTypes = {
  theme: PropTypes.object,
  isVisible: PropTypes.bool,
  onCloseQuickAction: PropTypes.func,
  onDeviceNameChange: PropTypes.func,
};

export default withTheme(ChangeDeviceNameModal);
